import React, { Component }from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import checkPermission from '../Common/permissions';
//import {buttonStyle} from '../Common/style'

class InventoryRepackages extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
            gourpOpen: false
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchInventoryRepackages();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventoryRepackages is ready, reset state.

    componentWillReceiveProps(nextProps) {
        const PT = nextProps.inventoryRepackages;
        if (nextProps.inventoryRepackages && nextProps.inventoryRepackages != this.props.inventoryRepackages) {
            this.setState({
                rows: nextProps.inventoryRepackages
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    // Set inventoryRepackages being selected to be currentInventoryRepackage and navigate user to the edit page

    setCurrentInventoryRepackage(e) {
        e.preventDefault();
        const currentInventoryRepackage = this.state.selectedRows[0];
        this.props.resetCurrentInventoryRepackage();
        this.props.resetCurrentInventoryConvert();
        this.props.selectInventoryRepackage(currentInventoryRepackage);
        this.context.router.push('/inventories/repackage/' + currentInventoryRepackage.WarehouseRepackage_id)
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentInventoryRepackage();
        this.props.resetCurrentInventoryConvert();
        this.context.router.push('/inventories/repackage/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }


            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let rows = this.state.rows.slice(0);
                let editedRows = this.state.editedRows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                // if the element is already edited, remove the old one.
                editedRows.forEach((element, index) => {
                    if (element.Inventory_id === rows[e.rowIdx].Inventory_id)
                        editedRows.splice(index, 1)
                }, this);
                // push the row into the editedRows array
                editedRows.push(rows[e.rowIdx]);
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                    else return <span className="label label-danger"><Translate value="disable" /></span>;
                }
            });

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            // Column difinition

            const columns = [
                {
                    key: 'WarehouseRepackageNum',
                    name: <Translate value="record_repackage_no" />,
                    resizable: true,
                    width: 220,
                    sortable: true,
                    filterable: true,
                    locked: true
                },
                {
                    key: 'CreateTime',
                    name: <Translate value="create_date" />,
                    resizable: true,
                    width: 90,
                    sortable: true,
                    filterable: true,
                    formatter: DateFormatter
                },
                {
                    key: 'PostingDate',
                    name: <Translate value="repackage_date" />,
                    resizable: true,
                    width: 100,
                    sortable: true,
                    filterable: true,
                    formatter: DateFormatter
                },
                {
                    key: 'Modify_Username',
                    name: <Translate value="repackage_user" />,
                    resizable: true,
                    width: 150,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'Note',
                    name: <Translate value="note" />,
                    resizable: true,
                    width: 200,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'Completed',
                    name: <Translate value="completed" />,
                    resizable: true,
                    width: 100,
                    sortable: true,
                    filterable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryRepackages-dataGrid1">
                    <ReactDataGrid
                        rowKey='WarehouseRepackageNum'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        headerRowHeight={45}
                        minHeight={685}
                        onRowUpdated={handleRowUpdated}
                        enableRowSelect='single'
                        onRowSelect={onRowSelect}
                        />
                </div></Col></Row>
            )
        }
    }

    render() {
        return (
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="warehouse_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="inventory_repackage" />
                </Breadcrumb.Item>
              </Breadcrumb>
              <Grid id="inventory-repackage">
                <Panel className="position-relative table-collapse-fix">
                  <ButtonToolbar>
                      <Button href="/inventories"  bsStyle="btn btn-green marginLeftStyle" ><em className="fa fa-mail-reply"/></Button>
                      <Button bsStyle="primary" onClick={(e) => this.clickNew(e) } disabled={!checkPermission("add_warehouse_repackage")} >
                          <em className="fa fa-plus marginRightStyle" /><Translate value="create_inventory_repackage_sheet" />
                      </Button>
                      <Button bsStyle="primary">
                          <em className="fa fa-print marginRightStyle" /><Translate value="print" />
                      </Button>
                      <Button bsStyle="primary" disabled={!checkPermission("delete_warehouse_relocation")} >
                          <em className="fa fa-trash marginRightStyle"/><Translate value="delete" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        onClick={(event) => {this.setCurrentInventoryRepackage(event)}}
                        disabled={!checkPermission("change_warehouse_relocation")}
                      >
                          <em className="fa fa-pencil marginRightStyle" /><Translate value="edit" />
                      </Button>
                  </ButtonToolbar>
                  {this.renderTable() }
                </Panel>
              </Grid>
            </ContentWrapper>
        );
    }
}



export default InventoryRepackages;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryRepackages.jsx